export const PlusSwatchIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="9" cy="9" r="8.5" stroke="currentColor" />
            <line x1="4.5" y1="8.9082" x2="13.5" y2="8.9082" stroke="currentColor" />
            <line x1="8.9082" y1="13.5" x2="8.9082" y2="4.5" stroke="currentColor" />
        </svg>
    );
};
